var map = {
	"./MSPartner.png": 584,
	"./b3.png": 609,
	"./bg.png": 565,
	"./brain3tagline.png": 345,
	"./brain3tagline.svg": 757,
	"./conn.png": 458,
	"./conn.svg": 288,
	"./focus.png": 462,
	"./focus.svg": 194,
	"./info.png": 232,
	"./info.svg": 774,
	"./infra.png": 192,
	"./infra.svg": 208,
	"./lang.png": 488,
	"./loc.png": 664,
	"./logo-blue.png": 320,
	"./logo.png": 729,
	"./mail.png": 29,
	"./migration.png": 726,
	"./notdienst.png": 324,
	"./phon.png": 807,
	"./qmlogo.png": 803,
	"./redev.png": 874,
	"./redev.svg": 2,
	"./rollout.png": 57,
	"./team.png": 963,
	"./team.svg": 553
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;